module.exports = __webpack_public_path__ + "static/img/A104.b5c386f9.jpg";